var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoundedArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3548 18.0078L15.0689 13.4939L10.3548 8.98007C10.2423 8.87237 10.1531 8.7445 10.0922 8.60377C10.0313 8.46305 10 8.31222 10 8.1599C10 8.00758 10.0313 7.85675 10.0922 7.71603C10.1531 7.5753 10.2423 7.44743 10.3548 7.33973C10.4673 7.23202 10.6008 7.14658 10.7478 7.08829C10.8948 7.03 11.0523 7 11.2114 7C11.3704 7 11.5279 7.03 11.6749 7.08829C11.8219 7.14658 11.9554 7.23202 12.0679 7.33973L17.6446 12.6796C18.1185 13.1333 18.1185 13.8662 17.6446 14.3199L12.0679 19.6598C11.9555 19.7676 11.822 19.8532 11.675 19.9116C11.528 19.9699 11.3705 20 11.2114 20C11.0522 20 10.8947 19.9699 10.7477 19.9116C10.6007 19.8532 10.4672 19.7676 10.3548 19.6598C9.89311 19.2061 9.88096 18.4615 10.3548 18.0078Z",
    fill: "#AEA8A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 14C28 21.7385 21.7374 28 14 28C6.26151 28 0 21.7374 0 14C0 6.26151 6.26257 0 14 0C21.7385 0 28 6.26257 28 14ZM25.8125 14C25.8125 7.47061 20.5285 2.1875 14 2.1875C7.47061 2.1875 2.1875 7.47147 2.1875 14C2.1875 20.5294 7.47147 25.8125 14 25.8125C20.5294 25.8125 25.8125 20.5285 25.8125 14Z",
    fill: "#AEA8A8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedArrow);
export default __webpack_public_path__ + "static/media/rounded-arrow.e3e04766.svg";
export { ForwardRef as ReactComponent };